<script setup lang="ts">
import { ArrowRight } from 'lucide-vue-next'

import MarketingFlowTemplate from '@/views/autopilot/Components/MarketingFlowTemplate.vue'

import useTemplates from '@/views/autopilot/composables/templates'

const router = useRouter()
const { t } = useI18n()

const { templates } = useTemplates()

const selectedTemplates = computed(() => {
  return templates.value.filter((template) => template.isRecommended).slice(0, 3)
})

const goToTemplates = () => {
  router.push({
    name: 'MarketingFlowTemplates'
  })
}
</script>

<template>
  <div>
    <div class="flex flex-col gap-4 mb-4 md:flex-row md:items-center md:justify-between">
      <div class="flex flex-col gap-2">
        <p class="text-foreground font-medium">{{ t('pages.autopilot.autopilotsPage.templates.title') }}</p>
        <p class="text-sm font-normal text-muted-foreground">
          {{ t('pages.autopilot.autopilotsPage.templates.description') }}
        </p>
      </div>

      <Button variant="ghost-primary" class="self-start md:self-auto" @click="goToTemplates">
        {{ t('pages.autopilot.autopilotsPage.templates.discoverAll') }}
        <ArrowRight />
      </Button>
    </div>
    <div class="grid md:grid-cols-3 gap-4">
      <MarketingFlowTemplate :templates="selectedTemplates" />
    </div>
  </div>
</template>
